import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a89e7a90"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: "regions-view" }
const _hoisted_2 = { class: "ticket-config__title-wrapper" }
const _hoisted_3 = { class: "ticket-config__title" }
const _hoisted_4 = { class: "ticket-config__title-wrapper" }
const _hoisted_5 = { class: "ticket-config__top-title" }
const _hoisted_6 = { class: "ticket-config__title" }
const _hoisted_7 = { class: "ticket-config__title-wrapper" }
const _hoisted_8 = { class: "ticket-config__top-title" }
const _hoisted_9 = { class: "ticket-config__title" }
const _hoisted_10 = { class: "ticket-config__title-wrapper" }
const _hoisted_11 = { class: "ticket-config__top-title" }
const _hoisted_12 = { class: "ticket-config__title" }
const _hoisted_13 = { class: "ticket-config__title-wrapper" }
const _hoisted_14 = { class: "ticket-config__top-title" }
const _hoisted_15 = { class: "ticket-config__title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!
  const _component_RegionView = _resolveComponent("RegionView")!
  const _component_TicketTypeView = _resolveComponent("TicketTypeView")!
  const _component_CalendarView = _resolveComponent("CalendarView")!
  const _component_DateListView = _resolveComponent("DateListView")!
  const _component_PersonsView = _resolveComponent("PersonsView")!
  const _component_SuccessView = _resolveComponent("SuccessView")!
  const _component_FullscreenModal = _resolveComponent("FullscreenModal")!

  return (_openBlock(), _createBlock(_component_FullscreenModal, {
    stepViews: _ctx.stepViews,
    steps: _ctx.steps,
    step: _ctx.step,
    onAddToCart: _ctx.onAddToCart,
    "button-config": _ctx.buttonConfig,
    onClose: _ctx.onCloseModal
  }, {
    default: _withCtx(() => [
      _createVNode(_component_LoadingSpinner, { loading: _ctx.isLoading }, null, 8, ["loading"]),
      (_ctx.stepViews[_ctx.step] === 'region')
        ? (_openBlock(), _createBlock(_Transition, {
            key: 0,
            name: "fade"
          }, {
            default: _withCtx(() => [
              _createElementVNode("section", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.translate('shop.ticket.configuration.region-view-title')), 1)
                ]),
                _createVNode(_component_RegionView, { onIsLoading: _ctx.onLoading }, null, 8, ["onIsLoading"])
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.stepViews[_ctx.step] === 'ticketType')
        ? (_openBlock(), _createBlock(_Transition, {
            key: 1,
            name: "fade"
          }, {
            default: _withCtx(() => [
              _createElementVNode("section", {
                key: "ticket-type-view",
                class: _normalizeClass(_ctx.isLoading? 'is-loading' : '')
              }, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.selectedRegion.isMainRegion ? _ctx.translate('shop.ticket.configuration.main-region') : _ctx.translate('shop.ticket.configuration.sub-region')) + " " + _toDisplayString(_ctx.selectedRegion.name), 1),
                  _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.translate('shop.ticket.configuration.ticket-type-view-title')), 1)
                ]),
                _createVNode(_component_TicketTypeView, { onIsLoading: _ctx.onLoading }, null, 8, ["onIsLoading"])
              ], 2)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.stepViews[_ctx.step] === 'calendar')
        ? (_openBlock(), _createBlock(_Transition, {
            key: 2,
            name: "fade",
            appear: ""
          }, {
            default: _withCtx(() => [
              _createElementVNode("section", {
                key: "calender-view",
                class: _normalizeClass(_ctx.isLoading? 'is-loading' : '')
              }, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.selectedRegion.isMainRegion ? _ctx.translate('shop.ticket.configuration.main-region') : _ctx.translate('shop.ticket.configuration.sub-region')) + " " + _toDisplayString(_ctx.selectedRegion.name) + " " + _toDisplayString(_ctx.selectedTicketName ? _ctx.selectedTicketName : _ctx.title), 1),
                  _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.translate('shop.ticket.configuration.calendar-view-title')), 1)
                ]),
                _createVNode(_component_CalendarView, {
                  defaultCatalogId: _ctx.defaultCatalogId,
                  defaultTicketId: _ctx.defaultTicketId,
                  onIsLoading: _ctx.onLoading
                }, null, 8, ["defaultCatalogId", "defaultTicketId", "onIsLoading"])
              ], 2)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.stepViews[_ctx.step] === 'dateList')
        ? (_openBlock(), _createBlock(_Transition, {
            key: 3,
            name: "fade",
            appear: ""
          }, {
            default: _withCtx(() => [
              _createElementVNode("section", {
                key: "date-list-view",
                class: _normalizeClass(_ctx.isLoading? 'is-loading' : '')
              }, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.selectedRegion.isMainRegion ? _ctx.translate('shop.ticket.configuration.main-region') : _ctx.translate('shop.ticket.configuration.sub-region')) + " " + _toDisplayString(_ctx.selectedRegion.name) + " " + _toDisplayString(_ctx.selectedTicketName ? _ctx.selectedTicketName : _ctx.title), 1),
                  _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.translate('shop.ticket.configuration.date-list-view-title')), 1)
                ]),
                _createVNode(_component_DateListView, {
                  defaultCatalogId: _ctx.defaultCatalogId,
                  defaultTicketId: _ctx.defaultTicketId,
                  onIsLoading: _ctx.onLoading
                }, null, 8, ["defaultCatalogId", "defaultTicketId", "onIsLoading"])
              ], 2)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.stepViews[_ctx.step] === 'persons' || _ctx.step === _ctx.stepViews.length)
        ? (_openBlock(), _createBlock(_Transition, {
            key: 4,
            name: "fade",
            appear: ""
          }, {
            default: _withCtx(() => [
              _createElementVNode("section", {
                key: "persons-view",
                class: _normalizeClass(_ctx.isLoading? 'is-loading' : '')
              }, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.selectedRegion.isMainRegion ? _ctx.translate('shop.ticket.configuration.main-region') : _ctx.translate('shop.ticket.configuration.sub-region')) + " " + _toDisplayString(_ctx.selectedRegion.name) + " " + _toDisplayString(_ctx.selectedTicketName ? _ctx.selectedTicketName : _ctx.title), 1),
                  _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.translate('shop.ticket.configuration.persons-view-title')), 1)
                ]),
                _createVNode(_component_PersonsView, { onIsLoading: _ctx.onLoading }, null, 8, ["onIsLoading"])
              ], 2)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.step === _ctx.stepViews.length)
        ? (_openBlock(), _createBlock(_Transition, {
            key: 5,
            name: "fade"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_SuccessView, {
                title: _ctx.title,
                successData: _ctx.successData,
                onCloseModal: _ctx.onCloseModal,
                onIsLoading: _ctx.onLoading
              }, null, 8, ["title", "successData", "onCloseModal", "onIsLoading"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["stepViews", "steps", "step", "onAddToCart", "button-config", "onClose"]))
}